import {BASE_SINGLE_ARG_NUMERIC_FUNCTION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_SINGLE_ARG_NUMERIC_FUNCTION,
  name: 'FACT',
  description: 'Takes factorial of each number in a column or a single number.',
  shortDescription: 'Factorial',
} satisfies AnalysisFunction;
